import { useCMSPageField } from '@/cms/fields'
import { tk, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'
import { MostBookedByLabel } from './MostBookedByLabel'

// Due to design, we need to use Typography component with custom styles
const Score = styled(Typography)`
  font-size: 52px;
  line-height: ${tk('font_line_height_xs')};
  margin-bottom: ${tk('spacing_md')}!important;

  @media ${tk('mq_tablet')} {
    margin-bottom: unset !important;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media ${tk('mq_tablet')} {
    flex-direction: row;
  }
`

const MostBookedByLabelWrapper = styled.div`
  @media ${tk('mq_desktop_md')} {
    display: none !important;
  }
`

export function Rating() {
  const ratingAverage = useCMSPageField('userReviews.ratingAverage')
  const shouldShowRatings = useCMSPageField('userReviews.shouldShowRatings')

  if (!shouldShowRatings)
    return null

  return (
    <Wrapper>
      <Score $variant="heading-2xl" as="div">
        {ratingAverage}
      </Score>
      <MostBookedByLabelWrapper>
        <MostBookedByLabel />
      </MostBookedByLabelWrapper>
    </Wrapper>
  )
}
